import axios from 'axios';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

const track = async (event) => {
  try {
    await axios.post(`${API}/track`, event, { timeout: 4000 });
  } catch (_) {
    // silent
  }
};

export const trackPageView = (path) => track({ type: 'page_view', path });
export const trackProductView = (slug) => track({ type: 'product_view', slug });
export const trackSearch = (query) => track({ type: 'search', query });

const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    trackPageView(pathname);
  }, [pathname]);
  return null;
};

export default PageTracker;
